var questionnaires = {
    loadSong: function (myaudio, play) {
        var audio = document.getElementById(myaudio);
        if (audio) {
            if (play) {
                audio.play();
            }
            else {
                audio.pause();
            }
        }
    },

    setImage: function (_image) {
        this.animationState = _image;
        switch (_image) {
            case 1:
                var sp = document.getElementById("studentPlaying");
                if (sp) sp.style.backgroundPositionX = "0px";
                break;
            case 2:
                var sp = document.getElementById("studentPlaying");
                if(sp) sp.style.backgroundPositionX = "-162px";
                break;
            case 3:
                var sp = document.getElementById("studentPlaying");
                if (sp) sp.style.backgroundPositionX = "-324px";
                break;
            case 4:
                var sp = document.getElementById("studentPlaying");
                if (sp) sp.style.backgroundPositionX = "-486px";
                break;
        }
    },

    startAnimation: function () {
        var thisAnimStudent = this;

        thisAnimStudent.animationState = 1;
        thisAnimStudent.otherAnimCnt = -1;
        thisAnimStudent.otherAnimCnt = 0;

        this.idAnimation = setInterval(function () {
            thisAnimStudent.setImage(thisAnimStudent.animationState);
            if (thisAnimStudent.animationState == 1) {
                thisAnimStudent.animationState = 2;
            } else if (thisAnimStudent.animationState == 2) {
                thisAnimStudent.animationState = 1;
            } else {
                if (thisAnimStudent.otherAnimCnt > 1) {
                    thisAnimStudent.animationState = 1;
                    thisAnimStudent.otherAnimCnt = 0;
                } else {
                    thisAnimStudent.otherAnimCnt++;
                }
            }
        }, 400);
    },


    finishAnimation: function () {
        clearInterval(this.idAnimation);
    },

    setCorrectAnimation: function () {
        this.setImage(4);
    },

    setNoMoreTriesAnimation: function () {
        this.setImage(3);
    },

    hideAnimation = function (_hide) {
        if (_hide)
            this.mainDiv.style.display = "";
        else
            this.mainDiv.style.display = "none";
    },
};